export default __webpack_public_path__ + "static/media/vip-banner-vn.f46d9fec.webp";